{
  "back": "Back",
  "noSongsTitle": "No Songs in Playlist",
  "noSongsDescription": "There aren't any songs in this playlist.",
  "notFoundTitle": "Playlist Not Found",
  "notFoundDescription": "We couldn't find that playlist."
}
